import { render, staticRenderFns } from "./VehiclesList.vue?vue&type=template&id=58380f2a&scoped=true&"
import script from "./VehiclesList.vue?vue&type=script&lang=js&"
export * from "./VehiclesList.vue?vue&type=script&lang=js&"
import style0 from "./VehiclesList.vue?vue&type=style&index=0&id=58380f2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58380f2a",
  null
  
)

export default component.exports